// To see this message, add the following to the `<head>` section in your
// views/layouts/application.html.erb
//
//    <%= vite_client_tag %>
//    <%= vite_javascript_tag 'application' %>
// console.log('Vite ⚡️ Rails')

// If using a TypeScript entrypoint file:
//     <%= vite_typescript_tag 'application' %>
//
// If you want to use .jsx or .tsx, add the extension:
//     <%= vite_javascript_tag 'application.jsx' %>

// console.log('Visit the guide for more information: ', 'https://vite-ruby.netlify.app/guide/rails')

// Example: Load Rails libraries in Vite.
//
// import * as Turbo from '@hotwired/turbo'
// Turbo.start()
//
// import ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()
//
// // Import all channels.
// const channels = import.meta.globEager('./**/*_channel.js')

// Example: Import a stylesheet in app/frontend/index.css
// import '~/index.css'

// import '~/application.css'
import "./app.css";
import { createBrowserRouter, RouterProvider, } from "react-router";
import React from "react";
import ReactDOM from "react-dom/client";
import { Application } from "./dx";
import { Customers, clientLoader as customersClientLoader } from "./customers";
import { Customer, clientLoader as customerClientLoader } from "./customer";
import { Sale, clientLoader as saleClientLoader } from "./sale";
import { SiteVisit, clientLoader as siteClientLoader, saveSiteVisit } from "./siteVisit";
import { callSync, Setup, clientLoader as setupClientLoader } from "./setup";
import { Shipment, clientLoader as shipmentClientLoader } from "./shipment";
import { Login, loginLoader, callLogin } from "./login";
import { Welcome, welcomeLoader,  callWelcomeSync } from "./welcome";
import { User, userLoader, userActions } from "./user";
import { Status, clientLoader as statusClientLoader } from "./status";
import { Activity, clientLoader as activityClientLoader } from "./activity";

const router = createBrowserRouter([
  {
    path: "/",
    element: <div className="h-full bg-black font-inter"><Application /></div>,
    children: [
      { 
        path: "/",
        Component: Login,
        loader: loginLoader,
        action: async ({request }) => {callLogin(request)},
      },
      { 
        path: "login",
        Component: Login,
        loader: loginLoader,
        action: async ({request }) => {callLogin(request)},
      },
      { 
        path: "customers",
        Component: Customers,
        loader: customersClientLoader
      },
      {
        path:"customers/:customerId",
        Component: Customer,
        loader: customerClientLoader
      },
      {
        path:"sitevisits",
        Component: SiteVisit,
        loader: siteClientLoader,
        action: async ({request }) => {saveSiteVisit(request)},
      },
      {
        path:"setup",
        Component: Setup,
        loader: setupClientLoader,
        action: async ({ request }) => {callSync(request)},
      },
      {
        path:"shipments",
        Component: Shipment,
        loader: shipmentClientLoader,
      },
      {
        path:"sales",
        Component: Sale,
        loader: saleClientLoader,
      },
      {
        path:"status",
        Component: Status,
        loader: statusClientLoader,
      },
      {
        path:"welcome",
        Component: Welcome,
        loader: welcomeLoader,
        action: async ({ request }) => {callWelcomeSync(request)},
      },
      {
        path:"user",
        Component: User,
        loader: userLoader,
        action: async ({ request }) => {userActions(request)},
      },
      {
        path:"activities",
        Component: Activity,
        loader: activityClientLoader,
      },
    ]
  },
]);

const root = document.getElementById("root");

ReactDOM.createRoot(root).render(
  <RouterProvider router={router} />
);


if (import.meta.env.PROD) {
  console.log("loading service worker")
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register("/service-worker.js");
  }
} else {
  console.log("skipping service worker")
}
